export default () => `
  query($paymentMethodId: Int!) {
    currentUser {
      savedPayments {
        reference
        variant
        createdAt
        cardNumber
        cardHolderName
        cardExpiryMonth
        cardExpiryYear
      }
    }
    checkout(paymentMethodId: $paymentMethodId) {
      paymentPublicKey
      generationTime
      adyenAuthorizePaymentUrl
      applePay {
        isAvailable
        checkoutRequest
        authorizePaymentUrl
      }
    }
    paths {
      authorizeMerchantsUrl
      termsAndConditionsUrl
    }
  }
`
